module.exports = __webpack_public_path__ + "static/russells-900696d6489886ec164af75e0176133f.jpg";